<template>
  <!-- 工单详情 -->
  <div class="smy__card-full-box">
    <Card
      class=""
      :bordered="false"
      :padding="0"
      >
      <p slot="title">
        账户管理
      </p>
    </Card>
      <div class="content">
        <Card
          class="smy__card-full card-left"
          :bordered="false"
          >
          <AgentManageLeft
          :accountList="accountList"
          />
        </Card>
        <div
          class="smy__card-full card-right"
          >
          <Card
          :bordered="false"
           style="margin-bottom:10px">
          <AgentManageTop
          :accountList="accountList"
          @callback="loadList()"
          />
        </Card>
        <Card
        :bordered="false"
        >
          <AgentManageRight
            ref="orderDetailRight"
            :accountList="accountList"
            :rechargeList="rechargeList"
            :rechargeCount="rechargeCount"
            :list="list"
            :count="count"
          />
        </Card>
      </div>
      </div>
  </div>
</template>

<script>
import AgentManageLeft from './AgentManageLeft'
import AgentManageTop from './AgentManageTop'
import AgentManageRight from './AgentManageRight'

export default {
  components: {
    AgentManageLeft,
    AgentManageTop,
    AgentManageRight
  },
  props: {
    orderId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      accountList: {},
      list: [],
      count: 0,
      rechargeList: [],
      rechargeCount: 0,
      pageSize: 10,
      pageIndex: 0
    }
  },
  watch: {
    orderId (val) {

    }
  },
  methods: {
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/agent/account/recharge/list', {
          params: {
            id: this.orderId,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        }),
        this.$http.get('/agent/account/recharge/count', {
          params: {
            id: this.orderId
          }
        })
      ]).then(this.$http.spread((res1, res2) => {
        this.rechargeList = res1.data
        this.rechargeCount = res2.data
        this.listLoading = false
      }))
      this.$http.get('/agent/account/info', {
        params: {
          id: this.orderId
        }
      }).then(res => {
        this.accountList = res.data
        this.listLoading = false
      })
    }
  },
  created () {
    this.loadList()
  }
  // beforeRouteEnter (to, from, next) {
  //   console.log()
  //   axios.all([
  //     axios.get(`/agent/account/info?${to.params.orderId}`),
  //     axios.get(`/agent/account/recharge/list?${to.params.orderId}`)
  //   ]).then(axios.spread((res1, res2) => {
  //     next(vm => {
  //       vm.accountList = res1.data
  //       vm.rechargeList = res2.data
  //     })
  //   }))
  // }
}
</script>

<style lang="less" scoped>
.content {
  margin-top: 10px;
  flex: 1;
  display: flex;
  .card-left {
    width: 300px;
    flex-shrink: 0;
  }

  .card-right {
    width: 100%;
    margin-left: 10px;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/agentManage/index.vue